import { Divider, DividerProps, useMantineTheme } from '@mantine/core'
import { getBorderColor } from 'config/themeOverride/getColor'

const XMDivider = (props: DividerProps) => {
  const theme = useMantineTheme()
  return <Divider color={getBorderColor('gray.2', theme)} {...props} />
}

export default XMDivider
